import Vue from 'vue'
import routerPageHook from '@assets/js/routerPageHook.js'
import VideoBlock from '@components/ui-components/video-block/component.js'
import titleLink from '@components/ui-components/title-link/component.js'
import mainService from '@components/ui-components/main-service/component.js'
import OwlCarousel from 'vue-owl-carousel'
import ChevronLeft from '@assets/img/ChevronLeft.svg?inline'
import ChevronRight from '@assets/img/ChevronRight.svg?inline'
import { mapState } from 'vuex'

import UIStories from '../components/base/stories/index.vue'
import { router } from '@src/routes'

export default {
  name: 'index',
  data() {
    return {
      template: '<main></main>',
      mainSwiperOption: {
        spaceBetween: 0,
        parallax: true,
        speed: 700,
        loop: true,
        autoplay: {
          delay: 8000,
        },
        pagination: {
          el: '.js-slider-pag',
          clickable: true,
        },
      },
      reviewsOption: {
        spaceBetween: 32,
        loop: true,
        cursor: 'grab',
        pagination: {
          el: '.js-reviews-pag',
          clickable: true,
        },
      },
      achievementsOption: {
        spaceBetween: 32,
        loop: true,
        cursor: 'grab',
        pagination: {
          el: '.js-achievements-pag',
          clickable: true,
        },
      },
      producerOwlOpts: {
        autoplay: true,
        loop: true,
        margin: 32,
        dots: false,
        nav: false,
        slideTransition: 'linear',
        autoplayTimeout: 4500,
        autoplayHoverPause: true,
        autoplaySpeed: 4500,
        responsive: {
          0: { items: 1.5, margin: 16 },
          920: { items: 3, margin: 20 },
          1160: { items: 4, margin: 20 },
          1300: { items: 4, margin: 24 },
          1640: { items: 5, margin: 40 },
          2000: { items: 5, margin: 56 },
        },
      },
      serviceSwiperOption: {
        slidesPerView: 3,
        spaceBetween: 30,
        navigation: {
          nextEl: '.services-swiper--btn-next',
          prevEl: '.services-swiper--btn-prev',
        },
        breakpoints: {
          920: {
            slidesPerView: 'auto',
            spaceBetween: 15,
          },
          1300: {
            slidesPerView: 2,
            spaceBetween: 15,
          },
        },
      },
    }
  },
  components: {
    'video-block-cmp': VideoBlock,
    'title-link-cmp': titleLink,
    'main-service-cmp': mainService,
    'ui-stories': UIStories,
    'producer-owl': OwlCarousel,
    'chevron-left-svg': ChevronLeft,
    'chevron-right-svg': ChevronRight,
  },
  computed: {
    ...mapState('mobile', ['isMobile']),
  },
  methods: {
    toVendorPage(path) {
      if (!path) return

      if (path.charAt(0) === '/') {
        if (router.currentRoute.path !== path) {
          router.push(path.replace(router.history.base, '')).catch(() => {})
        }
      } else {
        window.open(path, '_blank').focus()
      }
    },
  },
  ...routerPageHook,
  render(createElement) {
    return Vue.compile(this.template).render.call(this, createElement)
  },
}



// WEBPACK FOOTER //
// ./src/templates/pages/index.js